import { useQuery } from '@apollo/client';
import { GET_COMMUNITY_PROMPT_DETAILS } from '@communities/prompt-management/graphql';
import { transformErrors } from '@core/adapters/errors/transformError';
import { useMemo } from 'react';

export interface GetCommunityPromptDetailsInput {
  promptVersion?: string;
  type?: string;
}

export interface PromptDetailsResponse {
  communityPromptDetails: {
    prompt: string;
  } | null;
}

export function usePromptDetails(communityId?: string, input?: GetCommunityPromptDetailsInput) {
  const { data, loading, error, refetch } = useQuery<PromptDetailsResponse>(GET_COMMUNITY_PROMPT_DETAILS, {
    variables: {
      communityId,
      input,
    },
    fetchPolicy: 'cache-first',
    skip: !communityId || !input,
  });

  const errors = useMemo(() => {
    if (!error) return null;

    return transformErrors(error);
  }, [error]);

  return {
    promptDetails: data?.communityPromptDetails,
    loading,
    errors,
    refetch,
  };
}
